export { RankedTable } from './RankedTable.tsx';
